import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { POST_DEVICE_COLOURS } from '@app/constants/myDevices/deviceSettings/deviceColours'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestDone, apiRequestFailed, apiRequestSent } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/deviceColours'

const postDeviceColoursLogic = createLogic({
  type: POST_DEVICE_COLOURS,
  latest: true,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token } } } = getState()
    next({
      ...action,
      token,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(POST_DEVICE_COLOURS))
    try {
      Api.postDeviceColours(action.token, action.id, action.data)
      dispatch(apiRequestDone(POST_DEVICE_COLOURS))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('POST_DEVICE_COLOURS failed without error')
      }
    }
    done()
  },
})

export default postDeviceColoursLogic
